"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  notifications: 'Лента новостей',
  notificationsHint: 'Здесь собраны события, на которые Вам стоит обратить внимание',
  markAllAsRead: 'Прочитать все новости'
};